import { Component, Inject, Optional, ViewChild, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { AppointmentService } from '../../services/appointment.service';
import esLocale from '@fullcalendar/core/locales/es';
import { AppSettings } from '../../app.settings';
import { Router } from '@angular/router';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGrigPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';


import * as moment from 'moment';

export interface UsersData {
  name: string;
  id: number;
}

@Component({
  selector: 'app-assign-appointment',
  templateUrl: './assign-appointment.component.html',
  styleUrls: ['./assign-appointment.component.css']
})
export class AssignAppointmentComponent implements OnInit {

  @ViewChild('calendar') calendarComponent: FullCalendarComponent;

  calendarPlugins = [dayGridPlugin, timeGrigPlugin, interactionPlugin];

  appointment: any = {};
  local_data: any;
  officeId: any;
  api: any;

  constructor(public dialogRef: MatDialogRef<AssignAppointmentComponent>,
    private router: Router, private appointmentService: AppointmentService,
    private snackBar: MatSnackBar,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: UsersData) {
    this.local_data = { ...data };

  }

  ngOnInit() {
    setTimeout(() => {
      this.render();
    }, 100);
    if (this.local_data) {
      this.getBySectionalTypeAndOfficeId(this.local_data.sectionalType.id, this.local_data.officeId);
    }
  }

  render(response?: any) {
    this.api = this.calendarComponent.getApi();
    this.api.setOption('header', {
      left: 'title',
      center: '',
      right: 'prev, next'
    });
    this.api.setOption('timeZone', 'locale');
    this.api.setOption('locale', esLocale);
    this.api.setOption('eventLimit', true);
    this.api.setOption('eventLimit', 2);
    this.api.setOption('eventLimitText', 'turnos');
    this.api.setOption('allDaySlot', false);
    this.api.setOption('eventTimeFormat', {
      hour: '2-digit',
      minute: '2-digit'
    });

    if (response) {
      this.api.setOption('minTime', response.minTime);
      this.api.setOption('maxTime', response.maxTime);
      this.api.setOption('firstDay', response.firstDay);
      this.api.setOption('businessHours', {
        daysOfWeek: response.daysOfWeek,
        startTime: response.minTime,
        endTime: response.maxTime
      });
    }

    this.api.render();
  }

  snackBarMessage(msg: any, duration: any) {
    this.snackBar.open(msg, '', {
      duration: duration, panelClass: ['blue-snackbar']
    });
  }

  getBySectionalTypeAndOfficeId(sectionalTypeId: any, officeId: any) {
    this.appointmentService.getBySectionalTypeAndOfficeId(sectionalTypeId, officeId).subscribe((response: any) => {
      this.data = response;
      const url = AppSettings.API_ENDPOINT;
      const thisFunctions = this;
      this.api.addEventSource({
        url: `${url}/appointment/calendar/sectionalType/${sectionalTypeId}/office/${officeId}/available`,
        type: 'GET',
        cache: true,
        extraParams: {
          unlimited_period: true // quita el límite de máximo día de turnos configurado
        },
        failure: function (e: any) {
          const xhrResponse = JSON.parse(e.xhr.response);
          const message = xhrResponse && xhrResponse.status === 409 ? xhrResponse.message : 'Se produjo un error al cargar los turnos disponibles.';
          thisFunctions.snackBarMessage(message, 5000);
        },
        color: 'seaGreen',
        textColor: 'white'
      });
      this.render(response);
    }, (e: any) => {
      if (e.status === 409) {
        this.snackBarMessage(e.error.message, 5000);
      } else {
        this.snackBarMessage('Ocurrio un problema', 5000);
      }
    });
  }

  handleDateClick(calDate) {
    this.snackBarMessage('Día sin turnos', 5000);
  }

  eventClicked(calDate) {
    // Fixeo las fechas porque el calendar las devuelve mal, les aplico el timezone del server
    this.appointment.startIso = calDate.event.start.toISOString().replace('Z', '-03:00');
    this.appointment.endIso = calDate.event.end.toISOString().replace('Z', '-03:00');

    // Genero las fechas con la hora del urno y zona actual
    this.appointment.start = moment(calDate.event.start.toISOString().split('T')[0]).set('hour', calDate.event.start.getUTCHours()).set('minute', calDate.event.start.getUTCMinutes());
    this.appointment.end = moment(calDate.event.end.toISOString().split('T')[0]).set('hour', calDate.event.end.getUTCHours()).set('minute', calDate.event.end.getUTCMinutes());
  }

  cancelAppointment() {
    this.dialogRef.close({ event: 'Cancel' });
  }

  acceptAppointment() {
    if (this.appointment && this.appointment.start) {
      this.dialogRef.close({ event: 'Accept', data: this.appointment });
    } else {
      this.snackBarMessage('Debe seleccionar un turno', 5000);
    }
  }

}
